import React, { useState, useEffect } from 'react';
import { cn } from '../../lib/utils';

interface LoaderProps {
  className?: string;
  onExit?: () => void;
}

export const Loader: React.FC<LoaderProps> = ({ className, onExit }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Trigger exit animation after a short delay
    const exitTimer = setTimeout(() => {
      setIsExiting(true);
      // Call onExit callback after animation completes
      const callbackTimer = setTimeout(() => {
        if (onExit) onExit();
      }, 300); // Match the duration of the fadeOut animation
      return () => clearTimeout(callbackTimer);
    }, 1200); // Show loader for 1.2 seconds before starting exit

    return () => clearTimeout(exitTimer);
  }, [onExit]);

  return (
    <div className={cn(
      "fixed inset-0 flex items-center justify-center bg-white z-50 transition-opacity duration-300",
      isExiting ? "opacity-0" : "opacity-100",
      className
    )}>
      <div className="container text-center">
        <div className="kaya-text">
          <span className="letter">C</span>
          <span className="letter">A</span>
          <span className="letter">U</span>
          <span className="letter">D</span>
          <span className="letter">E</span>
        </div>
      </div>
    </div>
  );
};

export default Loader;